import api from '../lib/api';
import type { WhatsAppSession, QRCodeResponse } from '../types/api';

class SessionService {
  async getSessions(): Promise<WhatsAppSession[]> {
    const response = await api.get('/whatsapp/sessions');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }

  async getSession(sessionName: string): Promise<WhatsAppSession> {
    const response = await api.get(`/whatsapp/sessions/${sessionName}`);
    return response.data;
  }

  async createSession(data: Partial<WhatsAppSession>): Promise<WhatsAppSession> {
    const response = await api.post('/whatsapp/sessions', data);
    return response.data;
  }

  async updateSession(sessionName: string, data: Partial<WhatsAppSession>): Promise<WhatsAppSession> {
    const response = await api.put(`/whatsapp/sessions/${sessionName}`, data);
    return response.data;
  }

  async deleteSession(sessionName: string): Promise<void> {
    await api.delete(`/whatsapp/sessions/${sessionName}`);
  }

  async startSession(sessionName: string): Promise<void> {
    await api.post(`/whatsapp/sessions/${sessionName}/start`);
  }

  async stopSession(sessionName: string): Promise<void> {
    await api.post(`/whatsapp/sessions/${sessionName}/stop`);
  }

  async restartSession(sessionName: string): Promise<void> {
    await api.post(`/whatsapp/sessions/${sessionName}/restart`);
  }

  async getQRCode(sessionName: string): Promise<QRCodeResponse> {
    const response = await api.get(`/whatsapp/sessions/${sessionName}/qr`);
    return response.data;
  }

  async setDefaultSession(sessionName: string): Promise<void> {
    await api.put(`/whatsapp/sessions/${sessionName}`, { isDefault: true });
  }
}

export default new SessionService();